import type { FunctionComponent } from "react";
import { JsonLd } from "react-schemaorg";
import type { ExtendedWebSite, NewsMediaOrganization, Organization } from "schema-dts";

import { config } from "shared/data";
import { getAssetPrefix } from "shared/lib/utils";

export const AppLinkingData: FunctionComponent = () => (
  <>
    <JsonLd<Organization>
      item={{
        "@context": "https://schema.org",
        "@id": `${config.general.siteUrl}#organization`,
        "@type": "Organization",
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer support",
          telephone: "+852-2680-8888",
        },
        logo: `${getAssetPrefix()}/icons/scmp-icon-512x512.png`,
        name: "South China Morning Post",
        sameAs: [
          "https://www.facebook.com/southchinamorningpost/",
          "https://twitter.com/SCMPNews",
          "https://www.youtube.com/southchinamorningpost",
          "https://www.linkedin.com/company/south-china-morning-post",
          "https://www.instagram.com/scmpnews",
          "https://plus.google.com/b/109548181662196012156/+SouthChinaMorningPostSCMP",
        ],
        url: config.general.siteUrl,
      }}
    />
    <JsonLd<NewsMediaOrganization>
      item={{
        "@context": "https://schema.org",
        "@type": "NewsMediaOrganization",
        address: "19/F Tower One, Times Square, 1 Matheson Street, Causeway Bay, Hong Kong",
        correctionsPolicy: `${config.general.siteUrl}/policies-and-standards`,
        description:
          "First published in 1903, South China Morning Post is Hong Kong's premier English language newspaper and has the city's most affluent and influential readership. With a reputation for authoritative, influential and independent reporting on Hong Kong and China. The newspaper is supported with its online publication scmp.com and its Sunday edition, Sunday Morning Post.",
        diversityPolicy: `${config.general.siteUrl}/policies-and-standards`,
        ethicsPolicy: `${config.general.siteUrl}/policies-and-standards`,
        foundingDate: "1903-11-06",
        logo: `${getAssetPrefix()}/icons/scmp-icon-512x512.png`,
        masthead: `${config.general.siteUrl}/policies-and-standards`,
        name: "South China Morning Post",
        sameAs: [
          "https://en.wikipedia.org/wiki/South_China_Morning_Post",
          "https://www.facebook.com/scmp",
          "https://x.com/SCMPNews",
          "https://www.instagram.com/scmpnews",
          "https://www.youtube.com/southchinamorningpost",
          "https://www.linkedin.com/company/south-china-morning-post",
        ],
        telephone: "+852-2680-8888",
        unnamedSourcesPolicy: `${config.general.siteUrl}/policies-and-standards`,
        url: config.general.siteUrl,
        verificationFactCheckingPolicy: `${config.general.siteUrl}/policies-and-standards`,
      }}
    />

    <JsonLd<ExtendedWebSite>
      item={{
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "South China Morning Post",
        potentialAction: {
          "@type": "SearchAction",
          "query-input": "required name=search_term_string",
          target: {
            "@type": "EntryPoint",
            urlTemplate: `${config.general.siteUrl}/search/{search_term_string}`,
          },
        },
        url: config.general.siteUrl,
      }}
    />
  </>
);

AppLinkingData.displayName = "AppLinkingData";
